import React, { useMemo, useState } from "react"
import { Button, Collapse, Input } from "antd"
import { MdArrowBack, MdOutlineSearch } from "react-icons/md"
import faqCategories from "./faqContent"

const FAQ = ({ onBack }) => {
  const [query, setQuery] = useState("")
  const q = query.trim().toLowerCase()
  const categories = useMemo(() => faqCategories
    .map((c) => ({ ...c, items: q ? c.items.filter((i) => `${i.q} ${i.a}`.toLowerCase().includes(q)) : c.items }))
    .filter((c) => c.items.length), [q])

  return (
    <div className="min-w-0 max-w-[820px]">
      <Button type="link" icon={<MdArrowBack size={18} />} onClick={onBack} className="!px-0 mb-3 inline-flex items-center gap-1">Back to Dashboard</Button>
      <h3 className="text-[20px] lg:text-[24px] font-bold">Frequently Asked Questions</h3>
      <p className="dashboard-muted text-[15px] mt-1 mb-5">Find answers to common questions about writing, creating and collaborating with Morphosys.</p>
      <Input size="large" allowClear aria-label="Search FAQ" placeholder="Search questions and answers" prefix={<MdOutlineSearch size={20} color="#AAAAAA" />} value={query} onChange={(e) => setQuery(e.target.value)} className="mb-6" />
      {categories.length === 0 && <p className="dashboard-muted">No questions match “{query}”.</p>}
      {categories.map((c) => (
        <section key={c.title} className="mb-7" aria-label={c.title}>
          <h4 className="text-[17px] font-bold mb-3">{c.title}</h4>
          <Collapse
            key={q}
            expandIconPosition="end"
            className="bg-white"
            items={c.items.map((i) => ({
              key: i.q,
              label: <span className="font-semibold text-[15px]">{i.q}</span>,
              children: <p className="text-[15px] leading-relaxed text-[#444]">{i.a}</p>,
            }))}
          />
        </section>
      ))}
    </div>
  )
}

export default FAQ
